import { Link } from "react-router-dom";
import { FIRM, NAV_LINKS } from "../../lib/firm";

const FOOTER_NAV = [
  ...NAV_LINKS,
  { label: "Strategy Comparison", to: "/strategy-comparison-gate" },
  { label: "White Paper", to: "/white-paper-gate" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-cream border-t border-sage-soft"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="lg:col-span-5">
            <div
              className="font-serif text-deep-teal text-3xl lg:text-4xl leading-tight"
              data-testid="footer-wordmark"
            >
              Retirement Tax Consultants
            </div>
            <p className="mt-6 text-charcoal-teal text-sm leading-relaxed max-w-md">
              The retirement tax specialist between your CPA and your CFP.
              Boutique family-office coordination for affluent pre-retirees
              and retirees.
            </p>
            <div className="mt-8 text-[10px] tracking-overline uppercase font-semibold text-accent-gold">
              David Hyden, CFF&reg; &middot; NSSA&reg; &middot; IRMAACP&reg;
            </div>
          </div>

          {/* Office */}
          <div className="lg:col-span-3">
            <div className="text-[10px] tracking-overline uppercase font-semibold text-accent-gold mb-5">
              Office
            </div>
            <address className="not-italic text-sm text-deep-teal space-y-1.5">
              <div>{FIRM.address}</div>
              <div>{FIRM.cityState}</div>
              <div className="pt-3">
                <a
                  href={FIRM.phoneHref}
                  data-testid="footer-phone"
                  className="editorial-link"
                >
                  {FIRM.phone}
                </a>
              </div>
              <div>
                <a
                  href={`mailto:${FIRM.email}`}
                  data-testid="footer-email"
                  className="editorial-link"
                >
                  {FIRM.email}
                </a>
              </div>
            </address>
          </div>

          {/* Navigate */}
          <div className="lg:col-span-4">
            <div className="text-[10px] tracking-overline uppercase font-semibold text-accent-gold mb-5">
              Navigate
            </div>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-3">
              {FOOTER_NAV.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-deep-teal editorial-link"
                    data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href={`mailto:${FIRM.email}`}
                  className="text-sm text-deep-teal editorial-link"
                  data-testid="footer-nav-contact"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-sage-soft flex flex-col lg:flex-row lg:items-start lg:justify-between gap-6">
          <p className="text-xs text-charcoal-teal/60 italic max-w-3xl leading-relaxed">
            Retirement Tax Consultants, LLC provides retirement tax strategy
            consulting services. RTC is not a law firm and does not provide
            legal advice. RTC is not a licensed investment advisor and does
            not manage investment assets. Coordination with qualified tax
            counsel, appraisers, and other professionals is performed through
            RTC&rsquo;s professional network. Strategy suitability is determined
            on a case-by-case basis. Nothing on this website constitutes tax,
            legal, or investment advice.
          </p>
          <p className="text-xs text-charcoal-teal/70 whitespace-nowrap">
            © {new Date().getFullYear()} {FIRM.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
